<template lang="html">
  <section :id="cardId" class="distribution-channel-card">
    <base-card>
      <template v-slot:header>
        <card-header
          :id="headerId"
          :header-title="distributionChannel.name"
          :is-link="true"
          @on-card-header-click="goTo(ROUTE_NAMES.distributionChannelOverview)"
        />
      </template>

      <div ref="utPublished">
        <span>{{ $t("publishedDisplayElements") }}:</span>
        <a
          class="link-number"
          @click="goTo(ROUTE_NAMES.distributionChannelCustomDisplayElements)"
        >
          {{ distributionChannel.widgetsCount }}
        </a>
      </div>
      <div ref="utCount">
        <span>{{ $t("customerDomains") }}:</span>
        <a
          class="link-number"
          @click="goTo(ROUTE_NAMES.distributionChannelCustomerDomains)"
        >
          {{ distributionChannel.customerDomains }}
        </a>
      </div>
    </base-card>
  </section>
</template>

<script lang="js">
  import { ROUTE_NAMES } from "@/static/global-variables";
  import BaseCard from "@/components/card/BaseCard";
  import CardHeader from "@/components/card/CardHeader";

  export default  {
    name: "distribution-channel-card",
    components: {
      BaseCard,
      CardHeader
    },
    props: {
      id: {
        type: String
      },
      distributionChannel: {
        type: Object
      }
    },
    computed: {
      cardId() {
        return this.id || `distribution-channel-card-${this.distributionChannel.uuid}`;
      },
      headerId() {
        return `card-header-${this.distributionChannel.uuid}`;
      }
    },
    data () {
      return {
        ROUTE_NAMES
      }
    },
    methods: {
      goTo(name) {
        this.$router.push({
          name,
          params: {
            uuid: this.distributionChannel.uuid
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .distribution-channel-card {
    position: relative;
    width: 16rem;
    .link-number {
      color: var(--LINK_COLOR);
    }
  }
</style>
